import React from 'react';
import { Input as RSInput, InputProps as RsInputProps } from 'rsuite5';
import { FieldProps } from 'formik';

export interface InputProps extends Omit<RsInputProps, 'form'>, FieldProps {}

export default function Input({ field, form, ...props }: InputProps) {
  return (
    <RSInput
      name={field.name}
      value={field.value}
      onChange={(_, event) => field.onChange(event)}
      onBlur={field.onBlur}
      {...props}
    />
  );
}